import React from "react"
import "./Home.css"
import HomeHeader from "./HomeHeader";
import UsImg from "./UsImg";

const Home = () => (
    <div id="home-page">
        <div id="main-content">
            <HomeHeader />
            {/* <div className="text-center my-4">
                    <Link to="/rsvp" className="btn btn-pastel-green btn-lg">
                        Click here to RSVP to the baby shower :)
                </Link>
            </div> */}
            <UsImg />
        </div>
    </div>
);

export default Home;
